import Card from '../Card/Card';
import './MemberCard.css';
import ChevronLink from '../ChevronLink/ChevronLink';
import { useParams } from 'react-router-dom';
import MaleSvgAvatar from './MaleAvatarSvg';
import FemaleAvatarSvg from './FemaleAvatarSvg';

type ActiveMemberData = {
    id: number;
    firstName: string;
    lastName: string;
    gender: 0 | 1;
    inactive?: boolean;
    customCardContent?: React.ReactNode;
};

type InactiveMemberData = ActiveMemberData & {
    inactive: boolean;
    newPartyData?: PartyData;
};

export type MemberDataType = ActiveMemberData | InactiveMemberData;

type PartyData = {
    partyName: string;
    partyColor: string;
};

type Props = {
    className?: string;
    partyData: PartyData;
    memberData: MemberDataType;
    customCardContent?: React.ReactNode;
};

const MemberCard = ({ className, partyData, memberData, customCardContent }: Props) => {
    const { municipalitaId, bodyType, zastupitelstvoId } = useParams();

    return (
        <Card
            className='member-card'
            elevation={1}
            link={`/${municipalitaId}/${bodyType}/${zastupitelstvoId}/zastupitele/${memberData.id}`}
        >
            <div className='member-avatar'>
                {memberData?.gender === 0 ? (
                    <MaleSvgAvatar color={partyData.partyColor} />
                ) : (
                    <FemaleAvatarSvg color={partyData.partyColor} />
                )}
            </div>
            <div className='member-info'>
                <div className='member-card-content'>
                    <p className='member-name'>
                        {memberData.firstName} {memberData.lastName}
                    </p>
                </div>
                <div className='member-card-content' style={customCardContent ? { alignItems: 'center' } : {}}>
                    {customCardContent ? (
                        customCardContent
                    ) : (
                        <p style={{ color: partyData.partyColor }}>{partyData.partyName}</p>
                    )}
                    <ChevronLink chevronDirection='right' text='Detail' linkDisabled />
                </div>
            </div>
        </Card>
    );
};

export default MemberCard;
